/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LngStationList } from '../../models/lng-station-list';
import { LngStationSearchBody } from '../../models/lng-station-search-body';
import { SortDirection } from '../../models/sort-direction';

export interface SearchStationsLng$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the station's name
 *   * CITY : the station's city
 *   * CODE : the station's code
 */
  sortFieldName?: 'NAME' | 'CITY' | 'CODE';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search stations for LNG
     */
    body?: LngStationSearchBody
}

export function searchStationsLng$Json(http: HttpClient, rootUrl: string, params?: SearchStationsLng$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LngStationList>> {
  const rb = new RequestBuilder(rootUrl, searchStationsLng$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LngStationList>;
    })
  );
}

searchStationsLng$Json.PATH = '/custom/lng/stations/search';
